"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReactIcon = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ACTION_TO_ICON = {
    AccountSettings: react_1.default.createElement(icons_1.Account, null),
    Archive: react_1.default.createElement(icons_1.Archive, null),
    Analytics: react_1.default.createElement(icons_1.Analytics, null),
    Blueprint: react_1.default.createElement(icons_1.Blueprint, null),
    Clone: react_1.default.createElement(icons_1.Copy, null),
    Navigation: react_1.default.createElement(icons_1.BordersHorizontal, null),
    Tag: react_1.default.createElement(icons_1.Tag, null),
    BrandSetup: react_1.default.createElement(icons_1.StylesDuotone, null),
    "Mark As Template": react_1.default.createElement(icons_1.RemoveTemplate, null),
    PageValue: react_1.default.createElement(icons_1.Value, null),
    Engagement: react_1.default.createElement(icons_1.Engagement, null),
};
var getReactIcon = function (actionName) {
    return ACTION_TO_ICON[actionName];
};
exports.getReactIcon = getReactIcon;
